import { render, staticRenderFns } from "./4mPop.vue?vue&type=template&id=9d273c52"
import script from "./4mPop.vue?vue&type=script&lang=js"
export * from "./4mPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d273c52')) {
      api.createRecord('9d273c52', component.options)
    } else {
      api.reload('9d273c52', component.options)
    }
    module.hot.accept("./4mPop.vue?vue&type=template&id=9d273c52", function () {
      api.rerender('9d273c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mPop.vue"
export default component.exports